import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { StateService } from '../../../services/state/stateService';
import { State } from '../../../type/entities/state-type';

const useContractBlockedStates = (initialFilters = {}) => {

    const { user } = useSelector((state: RootState) => state.auth);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState<Record<string, any>>({
        limit: 999999,
        filter_filters: { ...initialFilters, entity: 'contract_blocked' }
    });

    const fetchContractBlockedStates = async () => {
        setIsLoading(true);
        try {
            const service = new StateService();
            let requestFilters = { ...filters };

            if (user?.id && !user.department) {
                requestFilters = {
                    ...requestFilters,
                    filter_filters: {
                        ...requestFilters.filter_filters,
                        ignore_department_filter: true
                    }
                };
            }

            const response = await service.listStatusesForSelect(requestFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = Object.values(
                    fetchedData.data.reduce((acc: any, state: State) => {
                        if (!acc[state.id]) {
                            acc[state.id] = {
                                value: state.id,
                                label: state.name,
                                color: state.color,
                                statusOrder: state.statusOrder,
                                initialStatus: state.initialStatus,
                                unsatisfactoryStatus: state.unsatisfactoryStatus,
                                requiresKoReason: state.requiresKoReason,
                                productTypes: [],
                            };
                        }

                        if (state.productTypes?.productType?.id) {
                            acc[state.id].productTypes.push(state.productTypes.productType.id);
                        }

                        return acc;
                    }, {})
                );

                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching contract blocked states:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getContractBlockedStatesList = (entity?: string | null, notShowStatusID?: string | null, showDraftStatus: (boolean | null) = true) => {
        let filteredData = data;
        if (!showDraftStatus) filteredData = filteredData.filter((state: any) => !state.draftStatus);
        if (entity) return filteredData.filter((state: any) => state.entity === entity);
        if (notShowStatusID) return filteredData.filter((state: any) => state.value !== notShowStatusID);
        return filteredData;
    };

    const addContractBlockedStatesFilter = (key: string, value: any) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            filter_filters: {
                ...prevFilters.filter_filters,
                [key]: value
            }
        }));
    };

    useEffect(() => {
        fetchContractBlockedStates();
    }, [filters]);

    return { fetchContractBlockedStates, getContractBlockedStatesList, addContractBlockedStatesFilter, isLoadingContractBlockedStates: isLoading };
};

export default useContractBlockedStates;
